<template>
    <div class="movidesk-chat-wrapper">
        <v-card
            elevation="24"
            v-if="isOpen && hasSupport"
            class="movidesk-chat-container"
        >
            <v-progress-linear
                v-if="loadingOverlay"
                indeterminate
                color="indigo"
            ></v-progress-linear>
            <iframe
                v-bind:src="iframeUrl"
                frameborder="0"
                class="movides-chat-iframe"
                v-bind:style="iframeSyle"
            >
            </iframe>
        </v-card>
    </div>
</template>

<script>
export default {
    data() {
        return {
            iframeSyle: {
                visibility: 'hidden',
            },
        }
    },
    computed: {
        isOpen() {
            return this.$store.getters['support/showDialog']
        },
        loadingOverlay() {
            return !this.$store.getters['support/loaded']
        },
        iframeUrl() {
            var url = process.env.VUE_APP_MOVIDESK_URI
            var key = process.env.VUE_APP_MOVIDESK_KEY
            var name =
                '?Name=' +
                encodeURIComponent(this.$store.getters['auth/user'].name)
            var email =
                '&Email=' +
                encodeURIComponent(this.$store.getters['auth/user'].email)

            return url + key + name + email
        },

        hasSupport() {
            return this.$store.getters['reseller/hasSupport']
        },
    },
    methods: {
        handleMovideskEvents(event) {
            if (
                event.data.action == 'loadingOverlayStatus' &&
                !event.data.data
            ) {
                this.$store.commit('support/switchLoadedState')
                this.iframeSyle.visibility = 'visible'
            }
        },
    },
    mounted() {
        this.iframeSrc
        window.addEventListener('message', this.handleMovideskEvents)
    },
    beforeDestroy() {
        window.removeEventListener('message', this.handleMovideskEvents)
    },
}
</script>

<style scoped>
.movidesk-chat-wrapper {
    position: absolute;
    height: 100%;
    width: 100%;
    pointer-events: none;
}

.movidesk-chat-container {
    position: fixed;
    bottom: 0;
    right: 20px;
    bottom: 20px;
    z-index: 999;
    pointer-events: auto;
    height: 535px;
    width: 340px;
}

@media screen and (max-width: 472px) {
    .movidesk-chat-container {
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 90%;
        height: 80vh;
    }
}

.movides-chat-iframe {
    height: 100%;
    width: 100%;
}
</style>
